module.exports = __webpack_public_path__ + "img/KyleIkoma.c4e582c9.jpg";